import useAppModalService from "../../../../hooks/useAppModalService";
import {useSelector} from "react-redux";
import {selectLocale, selectUserCultureLg} from "../../../../stores/account/account.selectors";
import PayoutInfoPopUp from "../../../../views/PopUps/PayoutInfoPopUp/PayoutInfoPopUp";
import {FormattedMessage} from "react-intl";
import TournamentTimer from "../../../TournamentTimer/TournamentTimer";
import React, {useEffect, useState} from "react";
import {selectPreSelectedParlayById} from "../../../../stores/pickX/pickX.selectors";
import _ from "lodash";
import ParlayCancelled from "../../../ParlayCancelled/ParlayCancelled";
import {useGetRollingPrizeQuery} from "../../../../stores/pickX/pickX.api";
import PrizeSlotsCounter from "../../../PrizeSlotsCounter/PrizeSlotsCounter";
import {getLeagueBySportId} from "../../../../utils/SportUtils";
import SportIcon from "../../../SportIcon/SportIcon";

const tKey = "lobbyView.contests.prePackageContest.prePackageContestCard"

const CreateFromPreSelectedParlayHeader = ({parlay, prizeAsset}) => {
    const {openModal} = useAppModalService();

    const theCultureLg = useSelector(selectUserCultureLg);
    const locale = useSelector(selectLocale);
    const preSelectedParlay = useSelector((state) => selectPreSelectedParlayById(state, parlay.Id.split('_')[1]));
    const {data: rollingPrize} = useGetRollingPrizeQuery({
        currency: preSelectedParlay.FeeCurrency,
        wager: preSelectedParlay.Fee,
        sportId: preSelectedParlay.SportIds[0],
        payoutModel: preSelectedParlay.PayoutModel
    });

    const payoutInfos = preSelectedParlay.getPayouts({rollingPrize, prizeAsset});
    const last = _.last(payoutInfos);

    const [isCompact, setIsCompact] = useState(false);
    useEffect(() => {
        const onScroll = () => setIsCompact(window.scrollY > 100);
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);


    const handleFullPayoutBtnClick = async () => {
        try {
            await openModal('payoutInfoPopUp', 'info', {
                title: 'Payout',
                subtitle: 'Payout subtitle',
                details: 'Some details about the modal',
                modalComponent: PayoutInfoPopUp
            }, {
                parlayName: preSelectedParlay.Name[locale],
                entryFee: preSelectedParlay.Fee,
                payoutInfos: payoutInfos,
                currency: preSelectedParlay.FeeCurrency,
                parlay: preSelectedParlay,
            });
        } catch (error) {
            console.error('Error opening modal:', error);
        }
    };

    return (
        <>
        {isCompact && <div className="CreateFromPreSelectedParlayHeaderSpacer"/>}
        <div className={`CreateFromPreSelectedParlayHeader ${getLeagueBySportId(preSelectedParlay.Name.en, preSelectedParlay.SportIds[0])}${isCompact ? ' compact' : ''}`}>
            <div className="name">
                <SportIcon sportId={preSelectedParlay.SportIds[0]}/>
                {preSelectedParlay.Name[locale]}
            </div>
            <div className="tournamentTimer">
                <TournamentTimer targetDate={new Date(parlay.DateStart)}
                                 cultureLg={theCultureLg}/>
            </div>
            <div className="payoutCol">
                {last && !last.prizeAsset && (
                    <div className="grandPrize">
                        <div className="grandPrizeLabel">
                            <FormattedMessage id={`${tKey}.grandPrize`}/>
                        </div>
                        <PrizeSlotsCounter toAmount={last.payout}
                                           currency={preSelectedParlay.FeeCurrency}
                                           showDecimal={last.payout < 1000}/>
                    </div>
                )}
                <div className="fullPayoutLink gold-background" onClick={handleFullPayoutBtnClick}>
                    <i className="fa-solid fa-circle-info"/>
                    <FormattedMessage id={`${tKey}.fullPayout`}/>
                </div>
            </div>
            {preSelectedParlay.IsCancel && <ParlayCancelled parlay={preSelectedParlay}
                                                            showReason={false}/>}
        </div>
        </>
    );
}

export default CreateFromPreSelectedParlayHeader;
